// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possible values for device state that represent the current state
 * @export
 */
export const UAState = {
    Executing: 'executing',
    NotAvailable: 'notAvailable',
    NotExecuting: 'notExecuting',
    OutOfService: 'outOfService'
} as const;
export type UAState = typeof UAState[keyof typeof UAState];


export function instanceOfUAState(value: any): boolean {
    for (const key in UAState) {
        if (Object.prototype.hasOwnProperty.call(UAState, key)) {
            if (UAState[key as keyof typeof UAState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UAStateFromJSON(json: any): UAState {
    return UAStateFromJSONTyped(json, false);
}

export function UAStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAState {
    return json as UAState;
}

export function UAStateToJSON(value?: UAState | null): any {
    return value as any;
}

export function UAStateToJSONTyped(value: any, ignoreDiscriminator: boolean): UAState {
    return value as UAState;
}

